import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { CoreCommonModule } from '@core/common.module';
import { IconsModule } from 'app/components/icons';

import { BelivHeaderComponent } from './beliv-header.component';

@NgModule({
  declarations: [BelivHeaderComponent],
  imports: [
    RouterModule,
    NgbModule,
    TranslateModule,
    CoreCommonModule,
    IconsModule
  ],
  exports: [BelivHeaderComponent]
})
export class BelivHeaderModule {}
